// extracted by mini-css-extract-plugin
module.exports = {"hidden":"cancelBtn_hidden__jidGi","textEmphasis":"cancelBtn_textEmphasis__orF5x","btn":"cancelBtn_btn__84ntV"};